module.exports = __webpack_public_path__ + "static/media/rewards_premium.55d426d0.png";